// extracted by mini-css-extract-plugin
export default {"tabPaneTitle":"Detailed_tabPaneTitle__qahkM"};